<template lang="pug">
v-dialog(
  v-model="dialog",
  fullscreen,
  hide-overlay,
  transition="dialog-bottom-transition"
)
  v-btn(
    v-if="dialogType === 'form'",
    slot="activator",
    dark,
    color="indigo",
    title="View Detail"
  )
    v-icon print
    | &nbsp; Print Preview

  template(v-slot:activator="{ on, attrs }")
    v-icon.mr-2(
      v-if="dialogType !== 'form'",
      slot="activator",
      small,
      title="View Detail",
      v-bind="attrs",
      v-on="on",
      color="blue"
      @click="getPreviewConfig"
    ) remove_red_eye

  v-card
    v-app-bar.navFixed(:color="color", height="48px;")
      img.mr-2(
        :src="dataPreview.headerLogo",
        height="34",
        @click="$router.push('/')",
        style="cursor: pointer"
      )
      v-toolbar-title(
        style="cursor: pointer; font-size: 18px; font-weight: 600; color: white"
      ) i-Memo Preview
      v-spacer
      v-toolbar-items
        v-btn(
          v-if="dialogType !== 'user' && (imItems.imStatus == 2 || imItems.imStatus == 3) && (imItems.imStatusLabel === i18n.status[9].name || imItems.imStatusLabel === i18n.status[3].name)",
          flat,
          title="Approval",
          @click="approvalDialog = true;genImCode()",
          dark,
          text
        ) 
          v-icon(title="Approval") assignment_turned_in
          | &nbsp;Approval
        v-dialog(
          v-if="dialogType !== 'user' && (imItems.imStatus == 2 || imItems.imStatus == 3) && (imItems.imStatusLabel === i18n.status[9].name || imItems.imStatusLabel === i18n.status[3].name)",
          v-model="approvalDialog",
          persistent,
          max-width="500px"
        )
          v-card
            v-card-title.headline.grey.lighten-3.mb-3 Approval Form
            v-card-text
              v-layout(wrap)
                v-flex(v-if="approverHasOtpFlag()" xs12 v-show="genAlertShow")
                  v-alert(type="success") The OTP code has been successfully sent to your email and whatsapp.
                v-flex(v-if="approverHasOtpFlag()" xs12 v-show="otpAlertShow")
                  v-alert(type="error")  OTP code is incorrect!
                v-flex(xs12)
                  v-radio-group(v-model="approval", row)
                    v-radio(
                      v-if="imItems.imStatus != 3",
                      label="Approve",
                      color="success",
                      value="7"
                    )
                    v-radio(
                      v-if="imItems.imStatus != 3",
                      label="Reject",
                      color="red",
                      value="8"
                    )
                    v-radio(
                      label="Need Review",
                      color="yellow darken-4",
                      value="3"
                    )
                  .mb-2(v-if="approval == 3", style="color: #000000") Please select the user to revise/review the memo. Approver will start from the selected user.
                v-flex(v-if="approval == 3", xs12)
                  v-select(
                    v-if="imItems.imUseAlias",
                    v-model="select",
                    :hint="jabatan",
                    :items="reviewer",
                    item-text="alias",
                    item-value="id",
                    label="Select",
                    persistent-hint,
                    return-object,
                    single-line,
                    dense
                  )
                  v-select(
                    v-else,
                    v-model="select",
                    :hint="jabatan",
                    :items="reviewer",
                    item-text="name",
                    item-value="id",
                    label="Select",
                    persistent-hint,
                    return-object,
                    single-line,
                    dense
                  )
                v-flex(xs12)
                  v-textarea.mt-3(
                    v-model="comment",
                    filled,
                    label="Comment (Optional)",
                    counter="150",
                    :rules="[rules.length(150)]"
                  )
                v-flex(xs12)
                  span Enter the OTP code for {{ imItems.imNo }}
                  div(
                    style="display: flex; flex-direction: row; margin-left: -10px"
                  )
                    VinputOtp(
                      ref="otpInput",
                      separator="-",
                      :num-inputs="4",
                      :should-auto-focus="true",
                      :is-input-num="true",
                      @on-change="otpOnChange",
                      @on-complete="handleOnComplete"
                    ) 
            v-card-actions.pb-5
              v-spacer
              v-btn(
                color="green",
                depressed,
                @click="reSendOtp()",
                style="color: white"
              ) Resend OTP
              v-btn.pl-4.pr-4(depressed, @click="handleClose")
                | Close

              v-btn.pl-4.pr-4(
                :disabled="(approval == null|| !select.hasOwnProperty('id') && approval == 3) || (comment != null && comment.length > 150) || otpcode == null || otpcode == '' || otpcode.length < 4",
                color="blue-secondary",
                depressed,
                @click="submit"
              ) Submit

        v-btn(
          v-if="dialogType !== 'user' && (imItems.imStatus == 2 || imItems.imStatus == 3) && ( imItems.imStatusLabel === i18n.status[3].name)" @click="getEditUrl(imItems._id)"
          dark
          text
        )
          v-icon edit
          | &nbsp; Edit

        v-menu(offset-y v-if="imItems.imFileLampiran")
          template(v-slot:activator="{ on, attrs }" v-if="imItems.imFileLampiran.length > 0")
            v-btn(
              text
              dark
              v-bind="attrs"
              v-on="on"
            )
              v-icon cloud_download
              | &nbsp; Attachments

          v-list(v-if="imItems.imFileLampiran.length > 0")
            v-list-item(
              v-for="(item, index) in imItems.imFileLampiran"
              :key="index"
            )
              v-list-item-title 
                a(@click="downloadFile(item.url)")
                  | {{ item.name }}

            v-list-item(v-if="imItems.imFileLampiran.length > 1")
              v-list-item-title 
                a(@click="downloadAllFile(imItems.imNo)")
                  | Download All (Zip)


        v-btn(dark, text, @click="printIM(imItems._id)")
          v-icon print
          | &nbsp; Print
        
        //- v-btn(v-if="imItems.imStatus==4||imItems.imStatus==8" dark text @click="shareIM()")
        //-   v-icon share
        //-   | &nbsp; Share
        //- v-dialog(v-model="share" persistent max-width="350px")
        //-   v-card
        //-       v-card-title(class="headline grey lighten-2") Share
        //-       v-flex(class="text-center")
        //-         ShareNetwork(v-for="network in networks" :key="network.key" :network="network.network" :title="network.network=='whatsapp' ? 'Subject: '+ sharing.title+' \\nBody: \\n' : sharing.title " :url="shortUrl" :description="sharing.description")
        //-           img(:src="network.img" width="80px" style="margin:20px 15px;")
        //-       v-spacer
        //-       v-flex(class="text-right pa-4")
        //-         v-btn( class="custom__padding-btn elevation-0" @click.native="share=false") Close

        v-btn(dark, text, @click.native="dialog = false")
          v-icon(title="Close") cancel
          | &nbsp;Close
    v-list.print-bg.padTop60(three-line, subheader)
      div(:id="imItems._id" style="height: 100%; min-height: 100vh;")
        .page(size="Auto")
          table#header-view.view-width.print-header(
            style="margin-bottom: 1.2rem"
          )
            tbody
              tr
                //- ============= JIKA MEMILIKI DATA LOGO ALIGN =============
                td.custom-td(
                  :style="`justify-content: ${imItems.imOrganization.logo_align}; display:flex`"
                  v-if="imItems.imOrganization.hasOwnProperty('logo_align')"
                )
                  div(
                    style="display: flex; width: auto; flex-direction: column; align-items: center; flex-direction: column"
                  )
                    img.height-60px(:src="imItems.imOrganization.logo") 
                    p.logo-title(
                      v-if="imItems.imOrganization.hasOwnProperty('is_show_name')"
                      v-show="imItems.imOrganization.is_show_name" style="text-align:center"
                    ) {{ imItems.imOrganization.name }}
                    p.fw-300.tagline(
                      v-if="imItems.imOrganization.hasOwnProperty('is_show_tagline')"
                      v-show="imItems.imOrganization.is_show_tagline" 
                      style="text-align:center"
                    ) {{ imItems.imOrganization.tagline }}

                td.custom-td(
                  :style="`justify-content: left; display:flex`"
                  v-else
                )
                  div(
                    style="display: flex; width: auto; flex-direction: column; align-items: center; flex-direction: column"
                  )
                    img.height-60px(:src="imItems.imOrganization.logo") 
                    p.logo-title(
                      v-if="imItems.imOrganization.hasOwnProperty('is_show_name')"
                      v-show="imItems.imOrganization.is_show_name" style="text-align:center"
                    ) {{ imItems.imOrganization.name }}
                    p.fw-300.tagline(
                      v-if="imItems.imOrganization.hasOwnProperty('is_show_tagline')"
                      v-show="imItems.imOrganization.is_show_tagline" 
                      style="text-align:center"
                    ) {{ imItems.imOrganization.tagline }}

          .view-width(style="font-size: 14px")
            h2(style="text-align: center; padding: 5px") {{imItems.imType == 6 ? 'PAYMENT REQUEST': imItems.imType == 5 ?'INTERNAL MEMO' : 'ANNOUNCEMENT'}}
            hr.custom-hr

            table.view-width(style="margin-top: 10px")
              tbody
                tr
                  td(style="font-size: 15px; width: 40%") 
                    strong To
                    i.fw-300 &nbsp;Kepada
                  td(style="font-size: 15px")
                    strong From
                    i.fw-300 &nbsp;Dari

                tr
                  td(valign="top")
                    ul.mt-n1
                      li(
                        v-for="(requestor, i) in imItems.imWorkflow.slice().reverse()",
                        :key="i",
                        style="font-size: 15px",
                        v-if="requestor.status != 5"
                      )
                        span {{ imItems.imUseAlias ? requestor.alias : requestor.name }}
                  td(valign="top")
                    ul.list-creator.mt-n1
                      li
                        span {{ imItems.imUseAlias ? imItems.imUser.alias : imItems.imUser.name }}
                      li 
                        strong Number
                        i.fw-300 &nbsp;Nomor
                        br
                        | {{ imItems.imNo }}
                      li
                        strong Date
                        i.fw-300 &nbsp;Tanggal
                        br
                        | {{ imItems.imReSubmitedDate && imItems.imReSubmitedDate != null ? getTanggal(imItems.imReSubmitedDate) : imItems.imDate ? getTanggal(imItems.imDate) : '-' }}
                      li(v-if="imItems.hasOwnProperty('imCategory')")
                        strong Category
                        i.fw-300  Kategori
                        br
                        | {{ imItems.imCategory }}
                      li
                        strong Subject
                        i.fw-300 &nbsp;Subjek
                        br
                        | {{ imItems.imPerihal }}

                tr
                  td(style="font-size: 15px; width: 40%") 
                    strong CC
                    i.fw-300 &nbsp;Tembusan
                    span(v-if="imItems.imCC == null") &nbsp;-

                tr(v-if="imItems.imCC != null") 
                  td(valign="top")
                    span(
                      v-for="(cc, index) in imItems.imCC",
                      v-if="index !== imItems.imCC.length - 1",
                      style="font-size: 15px"
                    ) {{ imItems.imUseAlias ? cc.alias : cc.name }},&nbsp;
                    span(v-else) {{ imItems.imUseAlias ? cc.alias : cc.name }}&nbsp;

            hr.custom-hr

            .content-memo
              strong Purpose
              i.fw-300 &nbsp;Tujuan
              .ck-content(v-html="imItems.imTujuan")
            .content-memo
              strong Background
              i.fw-300 &nbsp;Latar Belakang
              .ck-content(v-html="imItems.imLatarBelakang")
            .content-memo
              strong Propose
              i.fw-300 &nbsp;Mengusulkan
              .ck-content(v-html="imItems.imUsulan")

            span(style="font-weight: 500px") We are hereby submitting our request, your consideration and approval are highly appreciated. Thank you.
            br
            i.fw-300 Demikian permohonan ini kami buat, atas persetujuan Bapak/Ibu, kami ucapkan terima kasih.

            hr.custom-hr(style="margin-top: 2rem")

        .page.pagebreak(size="Auto", style="height: auto")
          strong Approval list for
          i.fw-300 &nbsp;Daftar persetujuan untuk
          p(style="font-size: 14px") No. {{ imItems.imNo }}

          .view-width.detail-wrap(
            style="position: relative; font-size: 14px; height: auto"
          )
            div(:class="setWmPosition()" v-if="wm.src != null")
              img(:src="wm.src")

            div(id="background" v-else)
              div(v-if="imItems.imStatus == 1")
                img.imgWaterMark(src="img/draft.png")
                //- .text-rotate.im-draft {{ imItems.imNo }}

              div(v-if="imItems.imStatus == 2")
                img.imgWaterMark-on-approval(src="img/on-approval.png")
                //- .text-rotate.im-on-approval {{ imItems.imNo }}

              div(v-if="imItems.imStatus == 4")
                img.imgWaterMark-fully-approved(src="img/fully-approved.png")
                //- .text-rotate.im-fully-approved {{ imItems.imNo }}

              div(v-if="imItems.imStatus == 5")
                img.imgWaterMark(src="img/withdraw.png")
                //- .text-rotate.im-withdraw {{ imItems.imNo }}

              div(v-if="imItems.imStatus == 8")
                img.imgWaterMark(src="img/rejected.png")
                //- .text-rotate.im-rejected {{ imItems.imNo }}

            table.view-width(
              border="1",
              style="margin: 10px 0; border: 1px solid black; border-collapse: collapse; text-align: center; z-index: 100"
            )
              tbody
                tr
                  td(colspan="3", style="") 
                    b Submitted by
                    i.fw-300 &nbsp;Diajukan Oleh
                tr(style="background: #f3f4f6")
                  td(width="36%") 
                    b Name&nbsp;
                      span(v-if="imItems.imHideTitle == false") & Position
                    br
                    i.fw-300 Nama&nbsp;
                      span(v-if="imItems.imHideTitle == false") & Jabatan
                  td(width="32%") 
                    b Comment
                    br
                    i.fw-300 Komentar
                  td(width="32%")
                    b Digital Signature
                    br
                    i.fw-300 Tanda Tangan Digital
                tr(height="80px")
                  td.px-3(width="40%")
                    b {{ imItems.imUseAlias ? imItems.imUser.alias : imItems.imUser.name }} {{ imItems.imHideTitle ? '' : '/ ' + imItems.imUser.position }}
                  td 
                    div(
                      v-if="imItems.imStatus == 3 && imItems.imWorkflow[0].status == 6"
                    ) Under Review
                  td 
                    .approved(v-if="imItems.imStatus == 5")
                      img(:src="dataPreview.icon_withdraw", style="height: 30px")
                      br
                      | {{ 'Withdraw' + (getWithdrawDate ? ' at ' + getTanggal(getWithdrawDate) : '') }}<br />
                    .approved(v-else-if="imItems.imStatus == 1") &nbsp;
                    .approved(
                      v-else-if="!(imItems.imStatus == 3 && imItems.imWorkflow[0].status == 6)"
                    )
                      img(:src="dataPreview.icon_full_approve", style="height: 30px")
                      br
                      | {{ imItems.imReSubmitedDate && imItems.imReSubmitedDate != null ? getTanggal(imItems.imReSubmitedDate) : imItems.imDate ? getTanggal(imItems.imDate) : '-' }}
                    .approved(v-else-if="imItems.imStatus == 3") {{ imItems.imDate ? getTanggal(imItems.imDate) : '-' }}

                tr
                  td(colspan="3", align="center", style="") 
                    b Approved by
                    i.fw-300 &nbsp;Disetujui Oleh
                tr(style="background: #f3f4f6")
                  td(width="36%") 
                    b Name&nbsp;
                      span(v-if="imItems.imHideTitle == false") & Position
                    br
                    i.fw-300 Nama&nbsp;
                      span(v-if="imItems.imHideTitle == false") & Jabatan
                  td(width="32%") 
                    b Comment
                    br
                    i.fw-300 Komentar
                  td(width="32%")
                    b Digital Signature
                    br
                    i.fw-300 Tanda Tangan Digital

                tr(
                  v-for="(item, index) in imItems.imWorkflow",
                  v-if="item.status != 5",
                  height="80px"
                )
                  td.px-3(width="40%")
                    b {{ imItems.imUseAlias ? item.alias : item.name }} {{ imItems.imHideTitle ? '' : item.position ? '/ ' + item.position : '' }}
                  td(v-if="imItems.imStatus == 3")
                    div(v-if="imItems.imStatus == 3 && item.status == 3") Under Review
                    div(
                      v-else-if="imItems.imStatus == 3 && item.date && (item.status == 6 || item.status == 9)"
                    ) 
                      | {{ item.comment !== null && item.comment !== '' && item.comment !== undefined ? item.comment : '' }}
                      //- br
                      //- | (Need Reapproval)
                    div(v-else) {{ item.comment !== null && item.comment !== '' && item.comment !== undefined && item.status != 6 && item.status != 3 && item.status != 9 ? item.comment : '' }}
                  td(
                    v-else-if="imItems.imStatus != 3 && imItems.hasOwnProperty('imReturn')"
                  )
                    div(
                      v-if="imItems.imStatus == 2 && item.id == imItems.imReturn[imItems.imReturn.length - 1].id && item.status != 7"
                    ) 
                      //- | Returned to {{ imItems.imReturn[imItems.imReturn.length-1].returnTo.fullname ? imItems.imReturn[imItems.imReturn.length-1].returnTo.fullname : imItems.imReturn[imItems.imReturn.length-1].returnTo.name }}
                      //- br
                      | {{ item.comment !== null && item.comment !== '' && item.comment !== undefined ? item.comment : '' }}
                      //- br
                      //- | (Need Reapproval)
                    div(
                      v-if="imItems.imStatus == 8 && item.id == imItems.imReturn[imItems.imReturn.length - 1].id && item.status != 7"
                    ) 
                      //- | Returned to {{ imItems.imReturn[imItems.imReturn.length-1].returnTo.fullname ? imItems.imReturn[imItems.imReturn.length-1].returnTo.fullname : imItems.imReturn[imItems.imReturn.length-1].returnTo.name }}
                      //- br
                      | {{ item.comment !== null && item.comment !== '' && item.comment !== undefined ? item.comment : '' }}
                    div(
                      v-else-if="imItems.imStatus == 2 && item.date && (item.status == 6 || item.status == 9) && item.id != imItems.imReturn[imItems.imReturn.length - 1].id"
                    ) 
                      | {{ item.comment !== null && item.comment !== '' && item.comment !== undefined ? item.comment : '' }}
                      //- br
                      //- | (Need Reapproval)
                    div(
                      v-else-if="imItems.imStatus == 8 && item.date && (item.status == 6 || item.status == 9) && item.id != imItems.imReturn[imItems.imReturn.length - 1].id"
                    ) 
                      | {{ item.comment !== null && item.comment !== '' && item.comment !== undefined ? item.comment : '' }}
                      //- br
                    div(v-else) {{ item.comment !== null && item.comment !== '' && item.comment !== undefined && item.status != 6 && item.status != 3 && item.status != 9 && imItems.imStatus != 5 ? item.comment : '' }}
                  td(v-else)
                    div {{ item.comment !== null && item.comment !== '' && item.comment !== undefined && item.status != 6 && item.status != 3 && item.status != 9 && imItems.imStatus != 5 ? item.comment : '' }}
                  td
                    template(v-if="imItems.imStatus != 5")
                      .approved(v-if="item.status == 7") 
                        img(:src="dataPreview.icon_full_approve", style="height: 30px")
                        br
                        | {{ getTanggal(item.date) }}<br />
                      .approved(v-else-if="imItems.imStatus == 3 && item.date") 
                        | {{ getTanggal(item.date) }}
                        br
                        | (Need Reapproval)
                      .approved(v-else-if="item.status == 8") 
                        img(:src="dataPreview.icon_reject", style="height: 30px")
                        br
                        | {{ getTanggal(item.date) }}<br />
                      .approved(
                        v-else-if="imItems.imStatus == 2 && imItems.hasOwnProperty('imReturn') && item.date"
                      )
                        | {{ getTanggal(item.date) }}
                        br
                        | (Need Reapproval)
                      .approved(
                        v-else-if="imItems.imStatus == 8 && imItems.hasOwnProperty('imReturn') && item.date"
                      )
                        | {{ getTanggal(item.date) }}
                      .approved.ff0000(v-else) &nbsp; <br />&nbsp; <br />&nbsp; <br />

            div(
              style="text-align: center; margin-top: 1rem; margin-bottom: 1rem"
            )
              div(
                style="font-size: 14px; font-weight: bold; color: red; text-align: center"
              ) QR code to validate the correctness of the information on the digital signature in this document.
              i.fw-300 Kode QR untuk memvalidasi kebenaran informasi pada tanda tangan digital dalam dokumen ini.
            p(style="text-align: center")
              img(
                :src="'data:image/png;base64, ' + imItems.qrcode",
                style="vertical-align: middle; width: 150px"
              )

          //- WATERMARK STATUS SHOW WHEN PRINT
          div(v-if="wm.src == null")
            div(v-if="imItems.imStatus == 1")
              img.imgWaterMarkPrint(src="img/draft.png")
              //- .text-rotate.im-draft-print {{ imItems.imNo }}

            div(v-if="imItems.imStatus == 2")
              img.imgWaterMark-on-approval-print(src="img/on-approval.png")
              //- .text-rotate.im-on-approval-print {{ imItems.imNo }}

            div(v-if="imItems.imStatus == 4")
              img.imgWaterMark-fully-approved-print(src="img/fully-approved.png")
              //- .text-rotate.im-fully-approved-print {{ imItems.imNo }}

            div(v-if="imItems.imStatus == 5")
              img.imgWaterMarkPrint-withdraw-print(src="img/withdraw.png")
              //- .text-rotate.im-withdraw-print {{ imItems.imNo }}

            div(v-if="imItems.imStatus == 8")
              img.imgWaterMark-rejected-print(src="img/rejected.png")
              //- .text-rotate.im-rejected-print {{ imItems.imNo }}

  v-overlay(:value="overlay")
    v-progress-circular(indeterminate, size="64")
</template>

<script>
import axios from "axios";
import md5 from "md5";
import { mapState } from "vuex";
import * as i18n from "../data/i18n.json";
import VinputOtp from "@/components/OtpInput.vue";

export default {
  name: "imViewApproval",
  components: {
    VinputOtp,
  },
  props: {
    dialogType: String,
    imItems: Object,
    userDetail: Object,
    tokenBe: String,
    color: String
  },
  data: () => ({
    i18n: i18n.default,
    dialog: false,
    approvalBtn: false,
    approvalDialog: false,
    approvalDialog2: false,
    dialogTg: false,
    tgDontRemind: false,
    comment: null,
    approvalflag: false,
    approval: null,
    kepadas: [],
    select: {},
    print: false,
    share: false,
    forwardNote: null,
    userForward: {},
    forwardDialog: false,
    users: [],
    qrImage: `/img/icons/loading.gif`,
    showImg: false,
    overlay: false,
    rules: {
      length: (len) => (v) =>
        (v || "").length <= len || `Comment must be less than 150 characters`,
    },
    otpcode: null,
    otpAlertShow: false,
    genAlertShow: false,
    dataPreview: {
      themeColor: "#D42A2A",
      headerLogo: require('../assets/imemo-white.png'),
      icon_full_approve: require('../assets/check-64.png'),
      icon_reject: require('../assets/close-64.png'),
      icon_withdraw: require('../assets/withdraw-64.png')
    },
    wm: {
      src: null,
      position: null,
      rotate: null,
      size: null
    },
  }),
  computed: {
    colorTheme: function () {
      return "#D42A2A";
    },

    ...mapState([
      "API_URL",
      "WE_URL",
      "sharing",
      "networks",
      "shortenUrl",
      "dataUsers",
    ]),
    // ngCompany: function(){
    //   let result = '';
    //   for(const item of this.dataCompanies) {
    //     if (item.name == this.imItems.imCompany) {
    //       result = item.path;
    //       break;
    //     }
    //   }
    //   return result;
    // },
    reverseImApprover: function () {
      return this.imItems.imApprover.slice().reverse();
    },
    getWithdrawDate: function () {
      let result = "";
      for (const item of this.imItems.imWorkflow) {
        if (item.status == 5) {
          result = item.date;
          break;
        }
      }
      return result;
    },
    reviewer: function () {
      let result = [];
      result.push(this.imItems.imUser);
      for (const wf of this.imItems.imWorkflow) {
        if (wf.status == 9 || wf.status == 3) break;
        result.push(wf);
      }
      return result;
    },
    jabatan: function () {
      if (this.select === this.imItems.imUser) {
        return this.select.position + " (Initiator)";
      }
      return this.select.position;
    },
    titleUser: function () {
      return this.userForward.title;
    },
    treasuryApprovers: function () {
      return this.imItems.imWorkflow.slice(
        0,
        this.imItems.imWorkflow.length - 2
      );
    },
    validators: function () {
      return this.imItems.imWorkflow.slice(this.imItems.imWorkflow.length - 2);
    },
    //- getCategory() {
    //-   let result = "";
    //-   for ( const item of this.i18n.category ) {
    //-     if ( item.value == this.imItems.imCategory ) {
    //-       result = item.text;
    //-       break;
    //-     }
    //-   }
    //-   return result;
    //- }
  },
  mounted: async function () {
    // this.$store.dispatch("fetchDataCompanies")
    if (!this.approvalflag) {
      if (this.dialogType === "ho") {
        this.approvalflag = true;
        // this.approval = this.imItems.imStatus == 3 ? "3" : "4";
      } else {
        this.approvalflag = true;
        // this.approval = this.imItems.imStatus == 3 ? "3" : "7";
      }
    }
    //- let userDatas = await this.getUsers();
    //- for (const item of userDatas.data) {
    //-   this.users.push(item);
    //- }

    this.$nextTick(function () {
      // Code that will run only after the
      // entire view has been rendered
      this.qrImage =
        process.env.VUE_APP_API_OLD +
        `/qr/generate/${this.imItems.imNo}/${this.imItems.imType}`;
    });
  },
  methods: {
      handleClose() {
        this.approval = null
        this.approvalDialog = false;
      },
     shareIM:function(){
      this.$store.dispatch("getShortenUrl",{im:this.imItems})
      .then(res => {
          this.shortUrl = res.data
          this.share = true
      })
    },
    submit() {
      this.overlay = true;

      var qString =  this.approverHasOtpFlag() ? 
                            {_id: this.imItems._id, status: parseInt(this.approval), comment: this.comment, backto: parseInt(this.approval) == 3 ? this.select : null, otp: this.otpcode} :
                            {_id: this.imItems._id, status: parseInt(this.approval), comment: this.comment, backto: parseInt(this.approval) == 3 ? this.select : null} ;

      let token = this.tokenBe;
      let config = {
        method: "put",
        url:
          process.env.VUE_APP_API_OLD +
          `/api/update/requests/${token}`,
        headers: { Authorization: `Bearer ${token}` },
        data: qString
      };
      axios(config)
        .then((res) => {
          if (res.status == 200) {
            setTimeout(() => {
                if (res.data.error) {
                  this.approvalDialog2 = false;
                  this.genAlertShow = false;
                  this.otpAlertShow = true;
                } else {
                  const dataUsers = this.getUserApprover();
                  this.dialog = false;
                  this.$toasted.success(res.data.message, { icon : 'check_circle'});
                  location.reload();
                }
              },
            1000);
          }
        });
    },
    getUsers: async function () {
      //- const config = {
      //-   method: "get",
      //-   url: `${this.WE_URL}/api/user`,
      //-   auth: {
      //-     username: 'imemo',
      //-     password: 'Ang3lT3n4n!#'
      //-   },
      //- };
      //- const dataUser = await axios(config);
      //- return dataUser;
    },
    handleClearInput() {
      this.$refs.otpInput.clearInput();
      this.otpcode = "";
    },
    printIM: function (id) {
      printJS({
        printable: id,
        type: "html",
        scanStyles: false,
        css: [
          "/stylesheets/approval.css",
          "/stylesheets/vuetify.min.css",
          "/stylesheets/ck-content.css",
        ],
      });
    },
    getTanggal: function (tgl) {
      //- let monthNames = ["January", "February", "March", "April", "May", "June","July", "August", "September", "October", "November", "December"];
      let tanggal = new Date(tgl);
      //- let month = tanggal.getMonth();
      let date = tanggal.getDate() < 10 ? '0'+tanggal.getDate() : tanggal.getDate();
      const month = tanggal.toLocaleString('default', { month: 'short' });
      let hour = tanggal.getHours() < 10 ? '0'+tanggal.getHours() : tanggal.getHours();
      let minutes = tanggal.getMinutes() < 10 ? '0'+tanggal.getMinutes() : tanggal.getMinutes();
      return date+' '+month+' '+tanggal.getFullYear()+' '+hour+':'+minutes;
    },
    countLeadtime: function (d1, d2) {
      const tgl1 = new Date(d1);
      const tgl2 = new Date(d2);
      const date1 = new Date(
        tgl1.getFullYear() + "-" + (tgl1.getMonth() + 1) + "-" + tgl1.getDate()
      );
      const date2 = new Date(
        tgl2.getFullYear() + "-" + (tgl2.getMonth() + 1) + "-" + tgl2.getDate()
      );
      const timeDiff = Math.abs(date2.getTime() - date1.getTime());
      const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
      return diffDays;
    },
    downloadFile(files) {
      window.open(files, '_blank');
    },
    downloadAllFile(imNo) {
      //- window.location.href=process.env.VUE_APP_API+`/requests/download_zip/`+imNo
      this.overlay = true;
      const URL = process.env.VUE_APP_API+`/requests/download_zip/`+imNo;
      axios.head(URL)
        .then(response => {
            const statusCode = response.status;
            if (statusCode === 404 || statusCode === 500) {
                this.overlay = false;
                this.$toasted.error('Download failed!', { icon : 'error'})
            } else {
                this.overlay = false;
                window.location.href = URL;
            }      
        })
        .catch(err => {
            this.overlay = false;
            this.$toasted.error('Download failed!', { icon : 'error'})
        })
    },
    reSendOtp: async function() {
      const config = {
        method: "get",
        url: process.env.VUE_APP_API_OLD + `/gen-otp/resend/${this.imItems.imNo}/${this.tokenBe}`
      };
      let otp = await axios(config);
      if (otp.status == 200) {
        this.genAlertShow = true;
        this.otpAlertShow = false;
      }
    },
    handleOnComplete(value) {
      this.otpcode = value;
    },
    otpOnChange(value) {
      this.otpcode = value;
    },
    genImCode: async function() {
      this.otpAlertShow = false;
      if (this.approverHasOtpFlag()) {
        const config = {
          method: "get",
          url: process.env.VUE_APP_API_OLD + `/gen-otp/generate/${this.imItems.imNo}/${this.tokenBe}`
        };
        let otp = await axios(config);
        if (otp.status == 200) {
          this.genAlertShow = true;
        }
      }
    },
    approverHasOtpFlag: function () {
      var approver = null;
      for (let item in this.imItems.imWorkflow) {
        if (item.hasOwnProperty('username')) {
          if (item.username === this.viewer.username) {
            approver = item;
            break;
          }
        }
        if (item.hasOwnProperty('email')) {
          if (item.email === this.viewer.username) {
            approver = item;
            break;
          }
        }
      }
      if (this.imItems.imDate < '2030-01-01T00:00:00+07:00') return true;
      else {
        if (approver.hasOwnProperty('otpflag')) {
          if (approver.otpflag == 1) return true;
          return false;
        }
        return false;
      }
      //- if (approver.hasOwnProperty('otpflag')) {
      //-   if (approver.otpflag == 1) return true;
      //-   return false;
      //- }
      //- return false;
    },
    getUserApprover: function () {
      var approver = null;
      for (let item in this.imItems.imWorkflow) {
        if (item.hasOwnProperty('alias')) {
          if (item.username === this.viewer.username) {
            approver = item;
            break;
          }
        }
        if (item.hasOwnProperty('email')) {
          if (item.email === this.viewer.username) {
            approver = item;
            break;
          }
        }
      }
      return approver;
    },
    getEditUrl(id) {
      this.$router.push({
        name: "Edit Memo",
        params: { id: id },
      });
    },
    getPreviewConfig() {
     
        //- this.dataPreview.themeColor = this.imItems.imOrganization.settings.themeColors

      if ( this.imItems.imOrganization.hasOwnProperty('settings') && this.imItems.imOrganization.settings.hasOwnProperty('headerLogo') && this.imItems.imOrganization.settings.headerLogo.src != null ) {
        this.dataPreview.headerLogo = this.imItems.imOrganization.settings.headerLogo.src
      } else {
        this.dataPreview.headerLogo = require('../assets/imemo-white.png')
      }

      if ( this.imItems.imOrganization.hasOwnProperty('settings') && this.imItems.imOrganization.settings.hasOwnProperty('approvalSignIcon') && this.imItems.imOrganization.settings.approvalSignIcon.src != null ) {
        this.dataPreview.icon_full_approve = this.imItems.imOrganization.settings.approvalSignIcon.src
      } else {
        this.dataPreview.icon_full_approve = require('../assets/check-64.png')
      }

      if ( this.imItems.imOrganization.hasOwnProperty('settings') && this.imItems.imOrganization.settings.hasOwnProperty('rejectionSignIcon') && this.imItems.imOrganization.settings.rejectionSignIcon.src != null ) {
        this.dataPreview.icon_reject = this.imItems.imOrganization.settings.rejectionSignIcon.src
      } else {
        this.dataPreview.icon_reject = require('../assets/close-64.png')
      }

      if ( this.imItems.imOrganization.hasOwnProperty('settings') && this.imItems.imOrganization.settings.hasOwnProperty('withdrawSignIcon') && this.imItems.imOrganization.settings.withdrawSignIcon.src != null ) {
        this.dataPreview.icon_withdraw = this.imItems.imOrganization.settings.withdrawSignIcon.src
      } else {
        this.dataPreview.icon_withdraw = require('../assets/withdraw-64.png')
      }

      if ( this.imItems.imStatus == 1 ) {
        
        if ( this.imItems.imOrganization.hasOwnProperty('settings') && this.imItems.imOrganization.settings.hasOwnProperty('draftWatermark') ) {
          this.wm.src = this.imItems.imOrganization.settings.draftWatermark.src
          this.wm.position = this.imItems.imOrganization.settings.draftWatermark.align
          this.wm.rotate = this.imItems.imOrganization.settings.draftWatermark.rotate
          this.wm.size = this.imItems.imOrganization.settings.draftWatermark.size
        }

      } else if ( this.imItems.imStatus == 2 ) {

        if ( this.imItems.imOrganization.hasOwnProperty('settings') && this.imItems.imOrganization.settings.hasOwnProperty('onApprovalWatermark') ) {
          this.wm.src = this.imItems.imOrganization.settings.onApprovalWatermark.src
          this.wm.position = this.imItems.imOrganization.settings.onApprovalWatermark.align
          this.wm.rotate = this.imItems.imOrganization.settings.onApprovalWatermark.rotate
          this.wm.size = this.imItems.imOrganization.settings.onApprovalWatermark.size
        }

      } else if ( this.imItems.imStatus == 4 ) {

        if ( this.imItems.imOrganization.hasOwnProperty('settings') && this.imItems.imOrganization.settings.hasOwnProperty('fullApprovedWatermark') ) {
          this.wm.src = this.imItems.imOrganization.settings.fullApprovedWatermark.src
          this.wm.position = this.imItems.imOrganization.settings.fullApprovedWatermark.align
          this.wm.rotate = this.imItems.imOrganization.settings.fullApprovedWatermark.rotate
          this.wm.size = this.imItems.imOrganization.settings.fullApprovedWatermark.size
        }

      } else if ( this.imItems.imStatus == 5 ) {

        if ( this.imItems.imOrganization.hasOwnProperty('settings') && this.imItems.imOrganization.settings.hasOwnProperty('withdrawWatermark') ) {
          this.wm.src = this.imItems.imOrganization.settings.withdrawWatermark.src
          this.wm.position = this.imItems.imOrganization.settings.withdrawWatermark.align
          this.wm.rotate = this.imItems.imOrganization.settings.withdrawWatermark.rotate
          this.wm.size = this.imItems.imOrganization.settings.withdrawWatermark.size
        }

      } else if ( this.imItems.imStatus == 8 ) {

        if ( this.imItems.imOrganization.hasOwnProperty('settings') && this.imItems.imOrganization.settings.hasOwnProperty('rejectedWatermark') ) {
          this.wm.src = this.imItems.imOrganization.settings.rejectedWatermark.src
          this.wm.position = this.imItems.imOrganization.settings.rejectedWatermark.align
          this.wm.rotate = this.imItems.imOrganization.settings.rejectedWatermark.rotate
          this.wm.size = this.imItems.imOrganization.settings.rejectedWatermark.size
        }
      }
    },
    setWmPosition() {
      if ( this.wm.position != null || this.wm.rotate != null || this.wm.size != null ) {
        
        let position = this.wm.position == 'left' ? 'img-wm__position-left' : this.wm.position == 'center' ? 'img-wm__position-center' : this.wm.position == 'right' ? 'img-wm__position-right' : 'img-wm__position-default';

        let rotate = '';

        if( this.wm.rotate ) {
          if (this.wm.position == 'left') {
            rotate = 'img-wm__rotate-90-left'
          } else if ( this.wm.position == 'center' ) {
            rotate = 'img-wm__rotate-90-center'
          } else {
            rotate = 'img-wm__rotate-90-right'
          }
        } else {
          rotate = '';
        }

        let size = this.wm.size == 'large' ? 'img-wm__size-xl' : 'img-wm__size-l';

        return position + ' ' + rotate +  ' ' + size;

      } else {
        return 'img-wm__default';
      }
    },
  },
};
</script>

<style scoped>
.print-bg {
  background: rgb(204, 204, 204) !important;
}
.print-bg > div {
  text-align: center;
}
.page {
  background: white;
  display: block;
  margin: 5px auto;
  padding: 0.7cm 1cm 0.8cm;
  position: relative;
}
.page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}
.page[size="Auto"] {
  width: auto;
  margin: 0 auto;
  display: inline-block;
  text-align: initial;
}
.view-width {
  width: 19cm;
}
.print-header {
  border-collapse: collapse;
  text-align: right;
}
.padding-x-3 {
  padding: 0 3px;
}
.padding-xy-5 {
  padding: 2px;
}
.padding-xy-1 {
  padding: 1px;
}
.margin-tl-5 {
  margin: 3px 5px 0 5px;
}
.margin-tl-10 {
  margin: 3px 10px 0 10px;
}
.margin-tl-25 {
  margin: 3px 15px 0 25px;
}
.logo-cell {
  padding: 8px 5px 0px;
  width: 35%;
}
.detail-wrap {
  margin-top: 5px;
}
.border-left-0 {
  border-left: 0;
}
.border-right-0 {
  border-right: 0;
}
.approved {
  font-size: 11px;
  padding: 13px;
}
.ff0000 {
  color: #ff0000;
}
.align-center {
  text-align: center;
}
.width-20p {
  width: 20%;
}
.width-25p {
  width: 25%;
}
.height-40px {
  height: 40px;
}
.width-300px {
  width: 250px;
}
.width-150px {
  width: 150px;
}
.top-align {
  vertical-align: top;
}

.tgLbl {
  position: relative;
  margin: 0 30px 0 10px;
  cursor: pointer;
  font-size: 14px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* The containerLbl */
.containerLbl {
  position: relative;
  padding-left: 20px;
  margin: 0 30px 0 10px;
  cursor: pointer;
  font-size: 12px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.containerLbl input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 15px;
  width: 15px;
  background-color: #eee;
}

/* On mouse-over, add a grey background color */
.containerLbl:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.containerLbl input:checked ~ .checkmark {
  background-color: #000000;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.containerLbl input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.containerLbl .checkmark:after {
  left: 5px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.navFixed {
  position: fixed;
  z-index: 9;
}
.padTop60 {
  padding-top: 60px;
}
.blink {
  -webkit-animation: blink 2s steps(5, start) infinite;
  animation: blink 2s steps(5, start) infinite;
  color: #fff;
}
@-webkit-keyframes blink {
  to {
    color: #ffffff;
  }
}
@keyframes blink {
  to {
    color: #ffffff;
  }
}
@media print {
  .page[size="Auto"] {
    width: auto;
    margin: 0 auto;
    display: block;
    text-align: initial;
  }
  table {
    page-break-inside: auto;
  }
  tr {
    page-break-inside: avoid;
    page-break-after: auto;
  }
  .pagebreak {
    page-break-before: always;
  } /* page-break-after works, as well */
  p {
    page-break-after: auto;
    page-break-before: auto;
    page-break-inside: avoid;
  }
  .image {
    padding: 5%;
    page-break-after: auto;
    page-break-before: auto;
    page-break-inside: avoid;
  }
  .table {
    page-break-after: auto;
    page-break-before: auto;
    page-break-inside: avoid;
  }
}
#background {
  position: absolute;
  z-index: 0;
  display: block;
  top: 0px;
  left: 0px;
  text-align: right;
  width: 100%;
}
.imgWaterMark {
  width: 10%;
  position: absolute;
  top: 0px;
  right: 10px;
}

/* ========== CUSTOM CSS =========== */
.fw-300 {
  font-weight: 300;
}

ul.list-creator {
  list-style-type: none;
  padding-left: 0;
}

ul.list-creator li {
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e1e1e1;
}

ul.list-creator li:nth-child(n + 2) {
  padding-top: 0.5rem;
}

hr.custom-hr {
  border: 0;
  border-top: 1.4px solid #1e1e1e;
  margin: 1em 0;
  padding: 0;
}

.content-memo {
  text-align: justify;
  margin-bottom: 1.4rem;
}

.content-memo strong {
  font-size: 16px;
}

.content-memo i {
  font-size: 16px;
}

.content-memo div {
  font-size: 14px;
}

.imgWaterMark-fully-approved {
  width: 7%;
  position: absolute;
  top: -50px;
  right: 10px;
}

.imgWaterMark-on-approval {
  width: 8%;
  position: absolute;
  top: -50px;
  right: 10px;
}

.text-rotate {
  position: absolute;
  right: 0;
  font-size: 60px;
  font-weight: 600;
  transform: rotate(90deg);
}

.im-withdraw {
  color: rgba(237, 27, 36, 0.1);
  top: 210px;
  right: -120px;
}

.im-rejected {
  color: rgba(237, 27, 36, 0.1);
  top: 190px;
  right: -110px;
}

.im-fully-approved {
  color: rgba(17, 182, 54, 0.1);
  top: 160px;
  right: -140px;
}

.im-on-approval {
  color: rgba(250, 255, 0, 0.1);
  top: 170px;
  right: -125px;
}

.im-draft {
  color: rgba(79, 79, 79, 0.1);
  top: 150px;
  right: -120px;
}

.v-toolbar__content {
  height: 48px;
}

div.divFooter {
  display: none;
}

.imgWaterMarkPrint {
  display: none;
}

.im-draft-print {
  display: none;
}

.imgWaterMark-fully-approved-print {
  display: none;
}

.imgWaterMark-on-approval-print {
  display: none;
}

.im-withdraw-print {
  display: none;
}

.im-rejected-print {
  display: none;
}

.im-fully-approved-print {
  display: none;
}

.im-on-approval-print {
  display: none;
}

.imgWaterMark-rejected-print {
  display: none;
}

.imgWaterMarkPrint-withdraw-print {
  display: none;
}

.height-60px {
  height: 60px;
  width: auto;
}

td.custom-td {
  vertical-align: middle;
}

td.custom-td img {
  vertical-align: middle;
  display: inline-block;
  margin-right: 0.6rem;
}

td.custom-td .inline-block {
  vertical-align: middle;
  display: inline-block;
}

td.custom-td .tagline {
  text-align: left;
}

.logo-title {
  font-size: 22px;
  font-weight: 600;
  color: #121212;
  margin-bottom: -0.4rem;
  text-align: left;
}

/** ============= CSS WATERMARK DINAMIS =========== **/

.img-wm{
  position: relative;
}

.img-wm__default img{
    -webkit-transform: rotate(90deg);
    -webkit-transform-origin: left top;
    -moz-transform: rotate(90deg);
    -moz-transform-origin: left top;
    -ms-transform: rotate(90deg);
    -ms-transform-origin: left top;
    -o-transform: rotate(90deg);
    -o-transform-origin: left top;
    transform: rotate(90deg);
    transform-origin: left top;

    position: absolute;
    top: 0;
    left: 98%;
    width: 500px;
    height: auto;
    opacity: 0.3;
}

.img-wm__position-left img{
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0.3;
}

.img-wm__position-center img{
  position: absolute;
  top: 0;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  opacity: 0.3;
}

.img-wm__position-right img{
  position: absolute;
  top: 0;
  right: 0;
  opacity: 0.3;
}

.img-wm__size-xl img{
  width: 500px;
  height: auto;
}

.img-wm__size-l img{
  width: 250px;
  height: auto;
}

.img-wm__rotate-90-left img{
  -webkit-transform: rotate(90deg);
  -webkit-transform-origin: left top;
  -moz-transform: rotate(90deg);
  -moz-transform-origin: left top;
  -ms-transform: rotate(90deg);
  -ms-transform-origin: left top;
  -o-transform: rotate(90deg);
  -o-transform-origin: left top;
  transform: rotate(90deg);
  transform-origin: left top;
  left: 25%;
}

.img-wm__rotate-90-center img{
  -webkit-transform: rotate(90deg);
  -webkit-transform-origin: left top;
  -moz-transform: rotate(90deg);
  -moz-transform-origin: left top;
  -ms-transform: rotate(90deg);
  -ms-transform-origin: left top;
  -o-transform: rotate(90deg);
  -o-transform-origin: left top;
  transform: rotate(90deg);
  transform-origin: left top;
  left: 60%;
}

.img-wm__rotate-90-right img{
  -webkit-transform: rotate(90deg);
  -webkit-transform-origin: left top;
  -moz-transform: rotate(90deg);
  -moz-transform-origin: left top;
  -ms-transform: rotate(90deg);
  -ms-transform-origin: left top;
  -o-transform: rotate(90deg);
  -o-transform-origin: left top;
  transform: rotate(90deg);
  transform-origin: left top;
  left: 95%;
}
</style>

<style>
.ck-content .image > img {
  display: block;
  margin: 0 auto;
  max-width: 80% !important;
}
</style>
